module.exports = __webpack_public_path__ + "img/cooperationContentImg3.ee7ce2ee.png";